// extracted by mini-css-extract-plugin
export var root = "video-module--root--aec13";
export var show = "video-module--show--87dcb";